import { getThresholdSchema } from './thresholdSchema';
import { units, getValidUnitsForType } from '../../../../units';

const getProperties = (variables = []) => ({
  title: {
    type: 'string',
    title: 'Title',
  },
  min: {
    type: 'integer',
    title: 'Minimum',
    default: 0,
  },
  max: {
    type: 'integer',
    title: 'Maximum',
    default: 100,
  },
  unit: {
    type: 'string',
    title: 'Unit',
    default: units[0].id,
    anyOf: getValidUnitsForType('gauge').map((unit) => ({
      const: unit.id,
      title: `${unit.category}: ${unit.name}`,
    })),
    description: 'Automatic unit conversion (e.g., kW to MW) is applied to default signal units',
  },
  unitLabel: {
    type: 'string',
    title: 'Custom unit label',
    description: 'This takes precedence over Unit',
  },
  decimals: {
    type: 'string',
    title: 'Decimals',
    default: 'auto',
    enum: ['auto', '0', '1', '2', '3', '4', '5'],
  },
  ...getThresholdSchema(variables),
});

export const getSchema = (variables = []) => ({
  type: 'object',
  properties: getProperties(variables),
});

export const schema = getSchema();

export const uiSchema = {
  unit: {
    'ui:field': 'customUnitLabel',
  },
  unitLabel: {
    'ui:field': 'customUnitLabel',
  },
  thresholds: {
    areaItems: {
      'ui:options': {
        orderable: false,
      },
    },
    linearItems: {
      'ui:options': {
        orderable: false,
      },
    },
  },
};
